export default __webpack_public_path__ + "static/media/ray11.5fbde3d7.webp";